/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Vault_TitleInputs */

const en_document_vault_title = /** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document Vault`)
};

const id_document_vault_title = /** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault Dokumen`)
};

/** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */
const es_document_vault_title = en_document_vault_title;

/** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */
const fr_document_vault_title = en_document_vault_title;

/** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */
const de_document_vault_title = en_document_vault_title;

/** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */
const ja_document_vault_title = en_document_vault_title;

/** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */
const zh_document_vault_title = en_document_vault_title;

/** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */
const ar_document_vault_title = en_document_vault_title;

/** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */
const it_document_vault_title = en_document_vault_title;

/** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */
const ru_document_vault_title = en_document_vault_title;

/** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */
const pt_document_vault_title = en_document_vault_title;

/** @type {(inputs: Document_Vault_TitleInputs) => LocalizedString} */
const ko_document_vault_title = en_document_vault_title;

/**
* | output |
* | --- |
* | "Document Vault" |
*
* @param {Document_Vault_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_vault_title = /** @type {((inputs?: Document_Vault_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Vault_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_vault_title(inputs)
	if (locale === "es") return es_document_vault_title(inputs)
	if (locale === "fr") return fr_document_vault_title(inputs)
	if (locale === "de") return de_document_vault_title(inputs)
	if (locale === "ja") return ja_document_vault_title(inputs)
	if (locale === "zh") return zh_document_vault_title(inputs)
	if (locale === "ar") return ar_document_vault_title(inputs)
	if (locale === "id") return id_document_vault_title(inputs)
	if (locale === "it") return it_document_vault_title(inputs)
	if (locale === "ru") return ru_document_vault_title(inputs)
	if (locale === "pt") return pt_document_vault_title(inputs)
	return ko_document_vault_title(inputs)
});